import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getDeliveryText } from 'site-modules/shared/utils/get-delivery-text';
import { DeliveryDetailsTooltip } from 'site-modules/shared/components/delivery-details-tooltip/delivery-details-tooltip';
import { get } from 'lodash-es';
import { isShowDeliveryDetails } from 'site-modules/shared/utils/is-show-delivery-details';
import { DATA_PATH } from 'client/engagement-handlers/inventory-engagement-handler/constants';

export function DeliveryCopy({ vinData = {}, price = null, textDelivery }) {
  const deliveryText = textDelivery || getDeliveryText({ vinData });
  const parentDealershipName = get(vinData, DATA_PATH.PARENT_DEALERSHIP_NAME);
  const deliveryOptions = get(vinData, 'computedDisplayInfo.deliveryOptions');
  const deliveryCost = get(deliveryOptions, 'deliveryCost');
  const deliveryCode = get(deliveryOptions, 'deliveryCode');
  const deliveryType = get(deliveryOptions, 'deliveryType');
  const deliveryDestinationName = get(deliveryOptions, 'deliveryDestination.name');

  const showDeliveryDetails = isShowDeliveryDetails({ parentDealershipName, deliveryCode });

  return (
    <div>
      {deliveryText}
      {showDeliveryDetails && (
        <Fragment>
          {' '}
          <DeliveryDetailsTooltip
            labelClassName="size-16"
            price={price}
            deliveryFee={deliveryCost}
            dealer={parentDealershipName}
            deliveryType={deliveryType}
            deliveryDestinationName={deliveryDestinationName}
          />
        </Fragment>
      )}
      <sup>‡</sup>
    </div>
  );
}

DeliveryCopy.propTypes = {
  vinData: PropTypes.shape({}),
  price: PropTypes.number,
  textDelivery: PropTypes.string,
};
